var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('PageHeaderUI',{attrs:{"title":"Booking Confirmed","breadcrumb":"Dashboard > Operations > Shipments"}}),_c('div',{staticClass:"h-8 w-full bg-white"}),_c('div',{staticClass:"p-3"},[_c('div',{staticClass:"h-10 w-full flex justify-end"}),(_vm.doorToDoorShow)?_c('BookingDirection',{attrs:{"aboutToExit":_vm.aboutToExit}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }